import {
  PlusCircleOutlined,
  ProfileOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Button, Form, Space, Tooltip } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import GenerarEnlaceModal from '../../../components/GenerarEnlaceModal';
import SelectableListModal from '../../../components/SelectableListModal';
import TableAndFilters from '../../../components/TableAndFilters';
import { errorHandler } from '../../../utils';
import { instanceRef } from '../../../utils/axios';
import { fieldTypes, filterConditions } from '../../../utils/filter-utils';

const CanalEnlace = () => {
  const {
    params: { idEmpresa, idCanal }
  } = useRouteMatch();

  const tableRef = useRef();
  const [canalInfo, setCanalInfo] = useState({});
  const [isModalEnlaceOpen, setIsModalEnlaceOpen] = useState(false);
  const [canalEnlace, setCanalEnlace] = useState();
  // const [productos, setProductos] = useState([]);
  const history = useHistory();

  const [enlaceForm] = Form.useForm();

  const getCanal = useCallback(async () => {
    try {
      //   setLoading(true);
      const response = await instanceRef.instance.get(`/canal/${idCanal}`);
      setCanalInfo(response.data?.data);
    } catch (error) {
      // message.error('Error al obtener canal', error);
    } finally {
      //   setLoading(false);
    }
  }, [idCanal]);

  const handleAsignarPlanes = async (value, idEnlacePadre) => {
    // setLoading(true);
    try {
      const idPlanes = value;
      const response = await instanceRef.instance.post('enlace/planes', {
        idEnlacePadre,
        idPlanes,
        idCanal
      });
      tableRef.current.reload();
      return response.data?.data;
    } catch (error) {
      errorHandler(error);
      return null;
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    if (idCanal) {
      getCanal();
    }
  }, [idCanal, getCanal]);

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const generarEnlaceCorto = () => {
    setIsModalEnlaceOpen(true);
    setCanalEnlace(canalInfo);
  };

  const columnsPlan = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    {
      title: 'Titulo',
      key: 'titulo',
      render: (record) => {
        if (record.titulo) return record.titulo;
        return `Plan ${record.id}`;
      }
    },
    /* {
      title: 'Producto',
      dataIndex: ['aseguradoraProducto', 'producto', 'descripcion'],
      filterType: fieldTypes.STRING
    }, */
    {
      title: 'Comision',
      key: 'comision',
      filterType: fieldTypes.STRING,
      render: (record) => {
        return `${record.comisionAseguradora.valor}%`;
      }
    }
  ];

  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },

    {
      title: 'Campaña',
      dataIndex: 'campanha',
      key: 'campanha'
    },
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      key: 'producto'
    },
    {
      title: 'Enlace original',
      dataIndex: 'enlace_original',
      key: 'enlace_original'
    },
    {
      title: 'Enlace corto',
      dataIndex: 'enlace_corto',
      key: 'enlace_corto'
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => {
        const planesAsignados = record.enlaceCanal.map((item) => ({
          id: item.id_plan
        }));
        return (
          <Space>
            <Tooltip title="Gestión de enlaces para usuarios" key={record.id}>
              <Button
                type="text"
                icon={<UserOutlined />}
                size="middle"
                onClick={() =>
                  handleOpenUrl(
                    `/canal-config-empresa/enlace-usuarios/${idEmpresa}/${idCanal}/${record.id}`
                  )
                }
              />
            </Tooltip>
            <SelectableListModal
              isMultiple
              title="Asignar Planes"
              placeholder="Buscar planes"
              width={1000}
              resetValue
              notNull
              iconButton={<ProfileOutlined />}
              columnsData={columnsPlan}
              url={`/plan/asignados/empresa/datatable?id_empresa=${idEmpresa}&id_producto=${record.producto?.id}`}
              key={record.id}
              setNewList={(value) => {
                handleAsignarPlanes(value, record.id);
              }}
              listChecked={planesAsignados}
              defaultFilters={{
                id_sucursal: {
                  value: canalInfo?.id_sucursal || 0,
                  filterType: fieldTypes.NUMERIC,
                  filterCondition: filterConditions.EQUALS
                }
              }}
            />
          </Space>
        );
      }
    }
  ];

  return (
    <div>
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        url="/enlace/all/canal"
        title={`
             Gestión de enlaces para canales | ${canalInfo?.descripcion} | ${canalInfo?.sucursal?.descripcion}`}
        columns={columns}
        defaultFilters={{
          id_canal: {
            value: idCanal,
            filterType: fieldTypes.NUMERIC,
            filterCondition: filterConditions.EQUALS
          }
        }}
        showTable
        hasExportar
        extra={[
          <Button
            key="enlaceCanalAdd"
            type="dashed"
            shape="round"
            icon={<PlusCircleOutlined />}
            size="middle"
            onClick={() => generarEnlaceCorto()}
          >
            Agregar Enlace Canal
          </Button>
        ]}
      />
      <GenerarEnlaceModal
        form={enlaceForm}
        idEmpresa={idEmpresa}
        isModalOpen={isModalEnlaceOpen}
        setIsModalOpen={setIsModalEnlaceOpen}
        canalEnlace={canalEnlace}
      />
    </div>
  );
};

export default CanalEnlace;
